export default __webpack_public_path__ + "static/beaconHealthOptions-8893c1e5ebb243ecbe92197a0ec63a06.svg";